<template>
  <div>
    <div class="card card-custom card-stretch gutter-b">
      <div class="card-header border-0 py-5">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label font-weight-bolder text-dark">
            Configurações gerais
          </span>
        </h3>
      </div>
      <b-card>
        <b-tabs v-model="abaConfiguracaoAtiva">
          <b-tab no-body title="NFe/NFCe">
            <b-card-footer>
              <div class="border-bottom border-light py-3">
                <b-col md="3">
                  <p class="font-weight-bolder text-dark mb-2">
                    Impressão retrato na Pré-venda
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Desativar/Ativar'">
                      <input type="checkbox" v-model="retratoImpressao" />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="3">
                  <p class="font-weight-bolder text-dark mb-2">
                    Margem de 4mm na NFC-e
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Desativar/Ativar'">
                      <input type="checkbox" v-model="margemNFCe" />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="3">
                  <p class="font-weight-bolder text-dark mb-2">
                    Imprimir NFC-e em A4
                  </p>
                  <span class="switch switch-icon">
                    <label
                      v-b-tooltip.hover.right="
                        'Quando ativo, a NFC-e será gerada somente em folha A4.'
                      "
                    >
                      <input type="checkbox" v-model="imprimir_nfce_a4" />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="3">
                  <p class="font-weight-bolder text-dark mb-2">
                    2 Vias na Pré-venda
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Desativar/Ativar'">
                      <input type="checkbox" v-model="viasPrevenda" />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Considerar desconto de ICMS na base do PIS/COFINS
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="descontar_icms_base_piscofins"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Vendas na NFCe no cartão devem ir para Contas a Receber?
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="vendas_cartao_conta_receber"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-row>
                  <b-col md="3">
                    <p class="font-weight-bolder text-dark mb-2">
                      Abertura de caixa
                    </p>
                    <span class="switch switch-icon">
                      <label v-b-tooltip.hover.right="'Não/Sim'">
                        <input type="checkbox" v-model="abertura_caixa" />
                        <span></span>
                      </label>
                    </span>
                  </b-col>
                  <b-col md="3" v-if="abertura_caixa">
                    <p class="font-weight-bolder text-dark mb-2">
                      Fechamento às cegas
                    </p>
                    <span class="switch switch-icon">
                      <label v-b-tooltip.hover.right="'Não/Sim'">
                        <input type="checkbox" v-model="fechamento_as_cegas" />
                        <span></span>
                      </label>
                    </span>
                  </b-col>
                </b-row>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Calcular ST considerando desconto do ICMS
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="calcular_st_desconto_icms"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-row>
                  <b-col md="3">
                    <p class="font-weight-bolder text-dark mb-2">
                      Impressão duplicata para NFCe
                    </p>
                    <span class="switch switch-icon">
                      <label v-b-tooltip.hover.right="'Não/Sim'">
                        <input type="checkbox" v-model="duplicata_nfce" />
                        <span></span>
                      </label>
                    </span>
                  </b-col>
                  <b-col md="3" v-if="duplicata_nfce">
                    <p class="font-weight-bolder text-dark mb-2">
                      Imprimir em 80 mm
                    </p>
                    <span class="switch switch-icon">
                      <label v-b-tooltip.hover.right="'Não/Sim'">
                        <input
                          type="checkbox"
                          v-model="impressao_duplicata_nfce_80_colunas"
                        />
                        <span></span>
                      </label>
                    </span>
                  </b-col>
                </b-row>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="5">
                  <p class="font-weight-bolder text-dark mb-2">
                    Importar OBS do cadastro do cliente para NFCe/Pré-Venda
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input type="checkbox" v-model="importar_obs_pessoa" />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>

              <div class="border-bottom border-light py-3">
                <b-col md="3">
                  <p class="font-weight-bolder text-dark mb-2">
                    Utilizar referência na gereção da Danfe
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input type="checkbox" v-model="referencia_danfe" />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>

              <div class="border-bottom border-light py-3">
                <b-col md="3">
                  <p class="font-weight-bolder text-dark mb-2">
                    Desconto Incondicional
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input type="checkbox" v-model="desconto_incondicional" />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>

              <div class="border-bottom border-light py-3">
                <b-col md="5">
                  <p class="font-weight-bolder text-dark mb-2">
                    Ordenar Impressão da Pré-Venda pela descrição dos produtos
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="ordenacao_produtos_prevenda"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="5">
                  <p class="font-weight-bolder text-dark mb-2">
                    Ordenar item adicionado por último no PDV
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="ordenar_item_adicionado_por_ultimo_pdv"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Somar Frete/Seguro/Outras/IPI despesas na Base ICMS
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="somar_frete_despesas_baseicms"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Integração com POS
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input type="checkbox" v-model="integracao_pos" />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Impressão paisagem Danfe
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="impressao_paisagem_danfe"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Não gerar impressão de Pré-vendas/NFCe
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input type="checkbox" v-model="nao_gerar_impressao" />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-row>
                  <b-col md="4">
                    <p class="font-weight-bolder text-dark mb-2">
                      Fixar natureza padrão na NFe
                    </p>
                    <span class="switch switch-icon">
                      <label v-b-tooltip.hover.right="'Não/Sim'">
                        <input type="checkbox" v-model="fixar_natureza_nfe" />
                        <span></span>
                      </label>
                    </span>
                  </b-col>
                  <b-col md="6" v-if="fixar_natureza_nfe">
                    <b-form-group
                      label="Natureza padrão da NFe"
                      label-for="natureza-nfe"
                    >
                      <VueSelect
                        id="natureza-nfe"
                        :filterable="false"
                        :options="naturezas_nfe"
                        v-model="natureza_nfe"
                        @search="onSearchNaturezaNFe"
                      >
                        <template slot="no-options">
                          Informe a natureza
                        </template>
                        <template slot="option" slot-scope="option">
                          <div class="d-center">
                            {{ option.descricao }} - {{ option.cfop.codigo }}
                          </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                          <div class="selected d-center">
                            {{ option.descricao }}
                          </div>
                        </template>
                      </VueSelect>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="3">
                  <p class="font-weight-bolder text-dark mb-2">
                    Não converter CFOP
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Desativar/Ativar'">
                      <input type="checkbox" v-model="nao_converter_cfop" />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="4">
                  <p class="font-weight-bolder text-dark mb-2">
                    Obrigatório informar vendedor NFCe/Pré-Venda
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Desativar/Ativar'">
                      <input type="checkbox" v-model="vendedor_obrigatorio" />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="4">
                  <p class="font-weight-bolder text-dark mb-2">
                    Importar OBS do cadastro do produto para NFe
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Desativar/Ativar'">
                      <input type="checkbox" v-model="importar_obs_produto" />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="4">
                  <p class="font-weight-bolder text-dark mb-2">
                    Não movimentar estoque na Pré-venda
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input type="checkbox" v-model="nao_movimentar_estoque" />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Gerar valores de PIS/COFINS com base no lucro da venda
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input type="checkbox" v-model="lucro_pis_cofins" />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Utilizar padrão CBS/IBS - Reforma Tributária
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="padrao_reforma_tributaria"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Utilizar código da balança
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input type="checkbox" v-model="usar_codigo_balanca" />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
            </b-card-footer>
          </b-tab>
          <b-tab no-body title="Compras">
            <b-card-footer>
              <div class="border-bottom border-light py-3">
                <b-col md="3">
                  <p class="font-weight-bolder text-dark mb-2">
                    Último NSU - Monitor NFe
                  </p>
                  <b-form-input v-model="ultimo_nsu"> </b-form-input>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Todas as compras devem gerar as parcelas em
                    Financeiro/Contas a pagar
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input type="checkbox" v-model="gerar_conta_pagar" />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Considerar quantidade tributável na importação do XML
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="considerar_qtd_tributavel"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>

              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Importar informações adicionais do item de forma automática
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="importar_desc_complementar"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>

              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Considerar a data de entrada na criação das contas a pagar
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="considerar_data_entrada"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
            </b-card-footer>
          </b-tab>
          <b-tab no-body title="Pedidos/Orçamentos/OS">
            <b-card-footer>
              <div class="border-bottom border-light py-3">
                <b-col md="3">
                  <p class="font-weight-bolder text-dark mb-2">
                    Impressão OS em 80 colunas
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="impressao_os_80_colunas"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Considerar OBS do produto em Orçamentos/Pedidos
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input type="checkbox" v-model="considerar_obs" />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>

              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Orçamento com foto
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input type="checkbox" v-model="orcamento_com_foto" />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>

              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Apresentar objeto/identificador no orçamento
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="apresentar_objeto_identificador_orcamento"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>

              <div class="border-bottom border-light py-3">
                <b-col md="3">
                  <p class="font-weight-bolder text-dark mb-2">
                    Impressão pedidos em 80 colunas
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="impressao_pedido_80_colunas"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>

              <div class="border-bottom border-light py-3">
                <b-col md="4">
                  <p class="font-weight-bolder text-dark mb-2">
                    Impressão de pedido faturado em 80 colunas
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="impressao_pedido_faturado_80_colunas"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>

              <div class="border-bottom border-light py-3">
                <b-col md="12">
                  <p class="font-weight-bolder text-dark mb-2">
                    Incluir mensagem adicional Pedidos/Orçamentos
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input type="checkbox" v-model="mensagem_adicional" />
                      <span></span>
                    </label>
                  </span>
                  <br />
                  <b-form-group
                    label="Mensagem"
                    label-for="mensagem_adicional_texto"
                    v-if="mensagem_adicional"
                  >
                    <v-textarea
                      full-width
                      no-resize
                      rows="1"
                      auto-grow
                      v-model="mensagem_adicional_texto"
                    ></v-textarea>
                  </b-form-group>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Impressão mensagem (art.1275, INCISO III DO CCB) na OS
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input type="checkbox" v-model="impressao_msg_os" />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="12">
                  <p class="font-weight-bolder text-dark mb-2">
                    Fixar observações nos PDFs
                  </p>
                  <div class="d-flex align-items-center mb-3">
                    <span class="switch switch-icon mr-4">
                      <label v-b-tooltip.hover.right="'Não/Sim'">
                        <input type="checkbox" v-model="fixar_observacao_os" />
                        <span></span>
                      </label>
                    </span>
                    <span class="font-weight-bolder text-dark mr-4"> OS </span>
                    <button
                      v-if="fixar_observacao_os"
                      class="btn btn-light-primary font-weight-bolder font-size-sm"
                      @click="abrirModalObservacaoFixa('os')"
                    >
                      Carregar mensagem
                    </button>
                  </div>
                  <div class="d-flex align-items-center">
                    <span class="switch switch-icon mr-4">
                      <label v-b-tooltip.hover.right="'Não/Sim'">
                        <input
                          type="checkbox"
                          v-model="fixar_observacao_orcamento"
                        />
                        <span></span>
                      </label>
                    </span>
                    <span class="font-weight-bolder text-dark mr-4">
                      Orçamento
                    </span>
                    <button
                      v-if="fixar_observacao_orcamento"
                      class="btn btn-light-primary font-weight-bolder font-size-sm"
                      @click="abrirModalObservacaoFixa('orcamento')"
                    >
                      Carregar mensagem
                    </button>
                  </div>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="12">
                  <p class="font-weight-bolder text-dark mb-2">
                    Custo Operacional
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input type="checkbox" v-model="custo_operacional" />
                      <span></span>
                    </label>
                  </span>
                  <br />
                  <b-col md="2">
                    <b-form-group
                      id="custo_percentual"
                      label-for="custo_percentual"
                      label="Custo %"
                      v-if="custo_operacional"
                    >
                      <money
                        class="form-control"
                        v-model="custo_percentual"
                        v-bind="configMoney"
                      >
                      </money>
                    </b-form-group>
                  </b-col>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Impressão código de barras nos Orçamentos
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="imprimir_codigo_barra_orcamento"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="3">
                  <p class="font-weight-bolder text-dark mb-2">
                    Impressão do orçamento em 80 colunas
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="impressao_orcamento_80_colunas"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="3">
                  <p class="font-weight-bolder text-dark mb-2">
                    Impressão do NCM
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input type="checkbox" v-model="impressao_ncm" />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Não imprimir dados do emitente
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="impressao_emitente_documentos"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Utilizar controle de horas no lançamento da OS
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input type="checkbox" v-model="trabalhar_horas_os" />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Utilizar número interno na OS
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="trabalhar_numero_interno_os"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Impressão reduzida pedido
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input type="checkbox" v-model="pedido_reduzido" />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Não imprimir referência dos produtos no Orçamento/Pedido
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="nao_imprimir_referencia"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Considerar Pedidos faturados no Dashboard
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="considerar_pedidos_faturados"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Considerar OS faturadas e NFSe feitas no Dashboard
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="considerar_os_faturadas_nfse_feitas"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
            </b-card-footer>
          </b-tab>
          <b-tab no-body title="NFSe" v-if="userAccessStore.access.nfse">
            <b-card-footer>
              <div class="border-bottom border-light py-3">
                <b-col md="12">
                  <p class="font-weight-bolder text-dark mb-2">
                    Informação complementar fixa
                  </p>
                  <b-form-input
                    maxlength="100"
                    v-model="informacao_nfse"
                  ></b-form-input>
                </b-col>
              </div>
            </b-card-footer>
          </b-tab>
          <b-tab no-body title="Restaurante" v-if="podeExibirRestaurante">
            <b-card-footer>
              <div class="border-bottom border-light py-3">
                <b-col md="10">
                  <div
                    class="d-flex flex-column flex-md-row align-items-md-center justify-content-between"
                  >
                    <div>
                      <p class="font-weight-bolder text-dark mb-2">
                        Canais digitais do restaurante
                      </p>
                      <p class="text-muted font-size-sm mb-2">
                        Cardápio Digital:
                        <strong
                          :class="
                            restaurante_cardapio_online_ativo
                              ? 'text-success'
                              : 'text-muted'
                          "
                        >
                          {{
                            restaurante_cardapio_online_ativo
                              ? "ativo"
                              : "inativo"
                          }}
                        </strong>
                        · Self Pedido:
                        <strong
                          :class="
                            restaurante_self_pedido_ativo
                              ? 'text-success'
                              : 'text-muted'
                          "
                        >
                          {{
                            restaurante_self_pedido_ativo ? "ativo" : "inativo"
                          }}
                        </strong>
                      </p>
                      <p class="text-muted font-size-sm mb-0">
                        Ativação, catálogo, horários, entrega, pagamento e
                        aparência agora são administrados em um único hub.
                      </p>
                    </div>
                    <router-link
                      class="btn btn-light-primary font-weight-bold mt-4 mt-md-0"
                      :to="{
                        name: 'restauranteCardapioOnline',
                        query: { secao: 'service', aba: 'channels' },
                      }"
                    >
                      Abrir Cardápio Digital
                    </router-link>
                  </div>
                </b-col>
              </div>

              <div class="border-bottom border-light py-3">
                <b-col md="8">
                  <p class="font-weight-bolder text-dark mb-2">
                    Etapa única na produção do restaurante
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="restaurante_producao_etapa_unica"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>

              <div class="border-bottom border-light py-3">
                <b-col md="8">
                  <p class="font-weight-bolder text-dark mb-2">
                    Usar apenas comandas
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="restaurante_usar_apenas_comandas"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>

              <div class="border-bottom border-light py-3">
                <b-col md="8">
                  <p class="font-weight-bolder text-dark mb-2">
                    Impressão 80 colunas dos pedidos do bar/restaurante
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="restaurante_impressao_pedidos_80_colunas"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>

              <div
                v-if="restaurante_impressao_pedidos_80_colunas"
                class="border-bottom border-light py-3"
              >
                <b-row>
                  <b-col md="3">
                    <b-form-group
                      id="restaurante_impressora_checkout"
                      label-for="restaurante_impressora_checkout"
                      label="Pedido/checkout"
                    >
                      <b-form-select
                        id="restaurante_impressora_checkout"
                        v-model="restaurante_impressora_checkout"
                        :options="restauranteImpressorasOptions"
                        :disabled="!restaurante_impressoras_qz.length"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group
                      id="restaurante_impressora_comprovante_cliente"
                      label-for="restaurante_impressora_comprovante_cliente"
                      label="Comprovante"
                    >
                      <b-form-select
                        id="restaurante_impressora_comprovante_cliente"
                        v-model="restaurante_impressora_comprovante_cliente"
                        :options="restauranteImpressorasOptions"
                        :disabled="!restaurante_impressoras_qz.length"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group
                      id="restaurante_impressora_cozinha"
                      label-for="restaurante_impressora_cozinha"
                      label="Cozinha"
                    >
                      <b-form-select
                        id="restaurante_impressora_cozinha"
                        v-model="restaurante_impressora_cozinha"
                        :options="restauranteImpressorasOptions"
                        :disabled="!restaurante_impressoras_qz.length"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group
                      id="restaurante_impressora_bar"
                      label-for="restaurante_impressora_bar"
                      label="Bar"
                    >
                      <b-form-select
                        id="restaurante_impressora_bar"
                        v-model="restaurante_impressora_bar"
                        :options="restauranteImpressorasOptions"
                        :disabled="!restaurante_impressoras_qz.length"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <button
                      type="button"
                      class="btn btn-light-primary font-weight-bold mr-2"
                      :disabled="restaurante_qz_carregando"
                      @click="carregarImpressorasRestaurante"
                    >
                      {{
                        restaurante_qz_carregando
                          ? "Conectando..."
                          : "Listar impressoras"
                      }}
                    </button>
                  </b-col>
                  <b-col md="8" class="d-flex align-items-center flex-wrap">
                    <button
                      type="button"
                      class="btn btn-light-success font-weight-bold mr-2 mb-2"
                      :disabled="!restaurante_impressora_checkout"
                      @click="testarImpressaoRestaurante('checkout')"
                    >
                      Testar checkout
                    </button>
                    <button
                      type="button"
                      class="btn btn-light-success font-weight-bold mr-2 mb-2"
                      :disabled="!restaurante_impressora_comprovante_cliente"
                      @click="testarImpressaoRestaurante('comprovante')"
                    >
                      Testar comprovante
                    </button>
                    <button
                      type="button"
                      class="btn btn-light-success font-weight-bold mr-2 mb-2"
                      :disabled="!restaurante_impressora_cozinha"
                      @click="testarImpressaoRestaurante('cozinha')"
                    >
                      Testar cozinha
                    </button>
                    <button
                      type="button"
                      class="btn btn-light-success font-weight-bold mb-2"
                      :disabled="!restaurante_impressora_bar"
                      @click="testarImpressaoRestaurante('bar')"
                    >
                      Testar bar
                    </button>
                  </b-col>
                </b-row>
                <div class="bg-light-primary rounded p-4 mt-3">
                  <p class="font-weight-bolder text-dark mb-1">
                    Confianca permanente do QZ Tray (impressao automatica)
                  </p>
                  <p class="text-muted mb-3">
                    Para o QZ Tray parar de pedir autorizacao a cada impressao e
                    nao mostrar o aviso de site nao confiavel, instale o
                    certificado do sistema uma unica vez neste computador.
                  </p>
                  <button
                    type="button"
                    class="btn btn-light-primary font-weight-bold mr-2 mb-2"
                    :disabled="restaurante_qz_baixando_certificado"
                    @click="baixarCertificadoQz"
                  >
                    {{
                      restaurante_qz_baixando_certificado
                        ? "Baixando..."
                        : "Baixar certificado"
                    }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-light-success font-weight-bold mr-2 mb-2"
                    :disabled="restaurante_qz_configurando_mac"
                    @click="configurarQzMac"
                  >
                    {{
                      restaurante_qz_configurando_mac
                        ? "Gerando..."
                        : "Configurar confianca (macOS)"
                    }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-light-success font-weight-bold mr-2 mb-2"
                    :disabled="restaurante_qz_configurando_windows"
                    @click="configurarQzWindows"
                  >
                    {{
                      restaurante_qz_configurando_windows
                        ? "Gerando..."
                        : "Configurar confianca (Windows)"
                    }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-light font-weight-bold mb-2"
                    @click="
                      restaurante_qz_ajuda_aberta = !restaurante_qz_ajuda_aberta
                    "
                  >
                    {{
                      restaurante_qz_ajuda_aberta
                        ? "Ocultar instrucoes"
                        : "Como instalar"
                    }}
                  </button>
                  <div
                    v-if="restaurante_qz_ajuda_aberta"
                    class="text-muted mt-2"
                  >
                    <p class="mb-2">
                      <strong>macOS:</strong> clique em
                      <strong>"Configurar confianca (macOS)"</strong> depois de
                      baixar o certificado. O script instala a confianca
                      permanente sem precisar editar pastas protegidas do
                      sistema.
                    </p>
                    <p class="mb-2">
                      <strong>Windows:</strong> clique em
                      <strong>"Configurar confiança (Windows)"</strong> depois
                      de baixar o certificado. Execute o <code>.bat</code>
                      baixado como administrador; ele copia o certificado para a
                      pasta do QZ Tray e reinicia o serviço.
                    </p>
                    <p class="mb-0">
                      Se o botao "Allow" aparecer desabilitado, o certificado
                      ainda nao foi confiado neste computador. Execute a
                      configuracao acima e reinicie o QZ Tray.
                    </p>
                  </div>
                </div>
                <small class="text-muted">
                  {{ restaurante_qz_status }}
                </small>
              </div>
            </b-card-footer>
          </b-tab>
          <b-tab no-body title="Gerais">
            <b-card-footer>
              <div class="border-bottom border-light py-3">
                <b-col md="4">
                  <p class="font-weight-bolder text-dark mb-2">
                    Verificar se a pessoa já está cadastrada
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="verifica_cadastro_pessoa"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="4">
                  <p class="font-weight-bolder text-dark mb-2">
                    Calcular Juros Simples
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input type="checkbox" v-model="juros_simples" />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-row v-if="juros_simples">
                  <b-col md="2">
                    <b-form-group
                      id="taxa_diaria"
                      label-for="taxa_diaria"
                      label="Taxa Mensal %"
                    >
                      <money
                        class="form-control"
                        v-model="taxa_diaria"
                        v-bind="configMoney"
                      >
                      </money>
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group id="multa" label-for="multa" label="Multa %">
                      <money
                        class="form-control"
                        v-model="multa"
                        v-bind="configMoney"
                      >
                      </money>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>

              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Cor Contas marcadas
                  </p>
                  <label v-b-tooltip.hover.right="'Cor das contas marcadas'">
                    <input type="color" v-model="contas_marcadas_color" />
                    <span></span>
                  </label>
                </b-col>
              </div>

              <div class="border-bottom border-light py-3">
                <b-col md="3">
                  <p class="font-weight-bolder text-dark mb-2">
                    Casas decimais preço
                  </p>
                  <b-form-select
                    placeholder=""
                    :options="casaDecimaisOptions"
                    v-model="casas_decimal_preco"
                  />
                </b-col>
              </div>

              <div class="border-bottom border-light py-3">
                <b-col md="3">
                  <p class="font-weight-bolder text-dark mb-2">
                    Casas decimais quantidade
                  </p>
                  <b-form-select
                    placeholder=""
                    :options="casaDecimaisOptions"
                    v-model="casas_decimal_quantidade"
                  />
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Solicitar senha de Admnistrador
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input type="checkbox" v-model="solicita_senha_adm" />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>

              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Utilizar sempre o campo referência para pesquisar os
                    produtos
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="utilizar_sempre_referencia"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>

              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Sincronizar os dados de cadastros com VendiZap
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input type="checkbox" v-model="sync_vendizap" />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>

              <div class="border-bottom border-light py-3">
                <b-col md="3">
                  <p class="font-weight-bolder text-dark mb-2">
                    Definir formato (.html) como padrão dos relatórios
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input type="checkbox" v-model="relatorios_html" />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>

              <div class="border-bottom border-light py-3">
                <b-col md="3">
                  <p class="font-weight-bolder text-dark mb-2">
                    Verificar estoque nas vendas
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input type="checkbox" v-model="verifica_estoque" />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>

              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Desconsiderar estoque em condicionais
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="desconsiderar_estoque_condicional"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>

              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Bloquear venda para cliente com inadimplência
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="bloquear_venda_cliente_inadimplente"
                      />
                      <span></span>
                    </label>
                  </span>
                  <b-row
                    v-if="bloquear_venda_cliente_inadimplente"
                    class="mt-3"
                  >
                    <b-col md="5">
                      <b-form-group
                        id="limite_inadimplencia_permitida"
                        label-for="limite_inadimplencia_permitida"
                        label="Valor limite permitido"
                      >
                        <money
                          class="form-control"
                          id="limite_inadimplencia_permitida"
                          v-model="limite_inadimplencia_permitida"
                          v-bind="configMoney"
                        >
                        </money>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </div>

              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Utilizar sempre o campo descrição para pesquisar os produtos
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="utilizar_sempre_descricao"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
              <div class="border-bottom border-light py-3">
                <b-col md="6">
                  <p class="font-weight-bolder text-dark mb-2">
                    Impressão recibo 80 colunas
                  </p>
                  <span class="switch switch-icon">
                    <label v-b-tooltip.hover.right="'Não/Sim'">
                      <input
                        type="checkbox"
                        v-model="impressao_recibo_80_colunas"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-col>
              </div>
            </b-card-footer>
          </b-tab>
          <b-tab no-body title="Balanças" lazy>
            <b-card-footer>
              <BalancaConfiguracao />
            </b-card-footer>
          </b-tab>
        </b-tabs>
      </b-card>
      <b-modal
        v-model="show_observacao_fixa_modal"
        :title="observacaoFixaModalTitle"
        hide-footer
      >
        <b-form-group label="Mensagem" label-for="observacao_fixa_mensagem">
          <b-form-textarea
            id="observacao_fixa_mensagem"
            v-model="observacao_fixa_modal_mensagem"
            :maxlength="observacao_fixa_limite"
            rows="4"
            no-resize
            @input="limitarObservacaoFixa"
          />
          <div class="d-flex justify-content-between mt-2">
            <small class="text-muted">
              Esta mensagem será enviada para impressão no PDF selecionado.
            </small>
            <small
              :class="
                observacaoFixaCaracteresRestantes < 0
                  ? 'text-danger'
                  : 'text-muted'
              "
            >
              {{ observacao_fixa_modal_mensagem.length }}/{{
                observacao_fixa_limite
              }}
            </small>
          </div>
        </b-form-group>
        <div class="d-flex justify-content-end">
          <button
            class="btn btn-light font-weight-bolder mr-2"
            @click="show_observacao_fixa_modal = false"
          >
            Cancelar
          </button>
          <button
            class="btn btn-primary font-weight-bolder"
            @click="salvarObservacaoFixa"
          >
            Salvar mensagem
          </button>
        </div>
      </b-modal>
      <div v-if="!abaBalancasAtiva" class="card-footer">
        <div class="row">
          <div class="col-lg-12" style="text-align: center">
            <button
              ref="submit_nova_configs"
              class="btn btn-primary font-weight-bold mt-5"
              @click="salvarConfigs"
            >
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { SistemaMixin } from "@/modules/Application";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";
import { userAccessStore } from "@/userAccessStore";
import { clienteInadimplenciaStore } from "@/modules/Application/stores/ClienteInadimplenciaStore";
import { FEATURES } from "@/core/constants/features";
import BalancaConfiguracao from "@/modules/Balanca/pages/Index.vue";
import {
  imprimirTextoQz,
  listarImpressorasQz,
  ticketTesteProducao,
} from "@/modules/Restaurante/services/qzTrayPrinter";
import _ from "lodash";

export default {
  name: "app-configuracoes-gerais",
  data() {
    return {
      userAccessStore,
      abaConfiguracaoAtiva: 0,
      configuracoes: null,
      retratoImpressao: false,
      margemNFCe: false,
      imprimir_nfce_a4: false,
      solicita_senha_adm: false,
      viasPrevenda: false,
      ultimo_nsu: null,
      verifica_cadastro_pessoa: false,
      abertura_caixa: false,
      fechamento_as_cegas: false,
      juros_simples: false,
      configMoney: settingMoney,
      taxa_diaria: 0,
      multa: 0,
      casaDecimaisOptions: [
        { value: 2, text: "2" },
        { value: 3, text: "3" },
        { value: 4, text: "4" },
        { value: 5, text: "5" },
        { value: 6, text: "6" },
        { value: 7, text: "7" },
      ],
      descontar_icms_base_piscofins: false,
      integracao_pos: false,
      vendas_cartao_conta_receber: false,
      contas_marcadas_color: null,
      impressao_os_80_colunas: false,
      impressao_msg_os: false,
      casas_decimal_preco: 2,
      casas_decimal_quantidade: 2,
      calcular_st_desconto_icms: false,
      duplicata_nfce: false,
      impressao_duplicata_nfce_80_colunas: false,
      gerar_conta_pagar: false,
      utilizar_sempre_referencia: false,
      considerar_qtd_tributavel: false,
      importar_desc_complementar: false,
      somar_frete_despesas_baseicms: false,
      sync_vendizap: false,
      considerar_obs: false,
      mensagem_adicional: false,
      mensagem_adicional_texto: null,
      impressao_pedido_80_colunas: false,
      impressao_pedido_faturado_80_colunas: false,
      relatorios_html: false,
      importar_obs_pessoa: false,
      referencia_danfe: false,
      desconto_incondicional: false,
      ordenacao_produtos_prevenda: false,
      ordenar_item_adicionado_por_ultimo_pdv: false,
      impressao_paisagem_danfe: false,
      verifica_estoque: false,
      custo_operacional: false,
      custo_percentual: 0,
      nao_gerar_impressao: false,
      fixar_natureza_nfe: false,
      natureza_nfe: null,
      naturezas_nfe: [],
      utilizar_sempre_descricao: false,
      nao_converter_cfop: false,
      imprimir_codigo_barra_orcamento: false,
      orcamento_com_foto: false,
      apresentar_objeto_identificador_orcamento: false,
      vendedor_obrigatorio: false,
      impressao_orcamento_80_colunas: false,
      impressao_ncm: false,
      impressao_recibo_80_colunas: false,
      informacao_nfse: null,
      impressao_emitente_documentos: false,
      trabalhar_horas_os: false,
      trabalhar_numero_interno_os: false,
      pedido_reduzido: false,
      importar_obs_produto: false,
      nao_imprimir_referencia: false,
      nao_movimentar_estoque: false,
      lucro_pis_cofins: false,
      considerar_data_entrada: false,
      considerar_pedidos_faturados: false,
      considerar_os_faturadas_nfse_feitas: false,
      padrao_reforma_tributaria: false,
      usar_codigo_balanca: false,
      bloquear_venda_cliente_inadimplente: false,
      limite_inadimplencia_permitida: 0,
      desconsiderar_estoque_condicional: false,
      fixar_observacao_os: false,
      fixar_observacao_orcamento: false,
      observacao_fixa_os: null,
      observacao_fixa_orcamento: null,
      observacao_fixa_limite: 255,
      observacao_fixa_modal_tipo: null,
      restaurante_producao_etapa_unica: false,
      restaurante_usar_apenas_comandas: false,
      restaurante_cardapio_online_ativo: false,
      restaurante_self_pedido_ativo: false,
      restaurante_impressao_pedidos_80_colunas: false,
      restaurante_impressora_checkout: null,
      restaurante_impressora_cozinha: null,
      restaurante_impressora_bar: null,
      restaurante_impressora_comprovante_cliente: null,
      restaurante_impressoras_qz: [],
      restaurante_qz_status:
        "Clique em listar impressoras para conectar ao QZ Tray.",
      restaurante_qz_carregando: false,
      restaurante_qz_baixando_certificado: false,
      restaurante_qz_configurando_mac: false,
      restaurante_qz_configurando_windows: false,
      restaurante_qz_ajuda_aberta: false,
      observacao_fixa_modal_mensagem: "",
      show_observacao_fixa_modal: false,
    };
  },
  components: {
    BalancaConfiguracao,
    Money,
    VueSelect,
  },
  mixins: [SistemaMixin],
  computed: {
    ...mapGetters(["itsblocked", "isNuts", "isRevenda", "hasFeature"]),
    abaBalancasIndex() {
      return (
        4 +
        (this.userAccessStore.access?.nfse ? 1 : 0) +
        (this.podeExibirRestaurante ? 1 : 0)
      );
    },
    abaBalancasAtiva() {
      return this.abaConfiguracaoAtiva === this.abaBalancasIndex;
    },
    podeExibirRestaurante() {
      return (
        this.hasFeature(FEATURES.MOD_FOOD) || this.isRevenda || this.isNuts
      );
    },
    observacaoFixaModalTitle() {
      return this.observacao_fixa_modal_tipo === "os"
        ? "Observação fixa da OS"
        : "Observação fixa do Orçamento";
    },
    observacaoFixaCaracteresRestantes() {
      return (
        this.observacao_fixa_limite - this.observacao_fixa_modal_mensagem.length
      );
    },
    restauranteImpressorasOptions() {
      const impressoras = [
        ...this.restaurante_impressoras_qz,
        this.restaurante_impressora_checkout,
        this.restaurante_impressora_cozinha,
        this.restaurante_impressora_bar,
        this.restaurante_impressora_comprovante_cliente,
      ]
        .filter(Boolean)
        .filter(
          (impressora, index, lista) => lista.indexOf(impressora) === index
        )
        .sort();

      if (!impressoras.length) {
        return [{ value: null, text: "Nenhuma impressora carregada" }];
      }

      return [
        { value: null, text: "Selecione a impressora" },
        ...impressoras.map((impressora) => ({
          value: impressora,
          text: impressora,
        })),
      ];
    },
  },
  methods: {
    normalizarObservacaoFixa(mensagem) {
      return String(mensagem ?? "").slice(0, this.observacao_fixa_limite);
    },
    abrirModalObservacaoFixa(tipo) {
      if (
        (tipo === "os" && !this.fixar_observacao_os) ||
        (tipo === "orcamento" && !this.fixar_observacao_orcamento)
      ) {
        return;
      }

      this.observacao_fixa_modal_tipo = tipo;
      this.observacao_fixa_modal_mensagem = this.normalizarObservacaoFixa(
        tipo === "os" ? this.observacao_fixa_os : this.observacao_fixa_orcamento
      );
      this.show_observacao_fixa_modal = true;
    },
    limitarObservacaoFixa(mensagem) {
      this.observacao_fixa_modal_mensagem =
        this.normalizarObservacaoFixa(mensagem);
    },
    salvarObservacaoFixa() {
      const mensagem = this.normalizarObservacaoFixa(
        this.observacao_fixa_modal_mensagem
      ).trim();

      if (this.observacao_fixa_modal_tipo === "os") {
        this.observacao_fixa_os = mensagem || null;
      } else {
        this.observacao_fixa_orcamento = mensagem || null;
      }

      this.show_observacao_fixa_modal = false;
    },
    async carregarNaturezaNFe(id) {
      if (!id) {
        this.natureza_nfe = null;
        this.naturezas_nfe = [];
        return;
      }

      try {
        const { data } = await this.$http.post("/natureza/find", { id });
        const natureza = data?.dados ?? data;

        this.natureza_nfe = natureza || null;
        this.naturezas_nfe = natureza ? [natureza] : [];
      } catch (error) {
        this.natureza_nfe = null;
        this.naturezas_nfe = [];
      }
    },
    onSearchNaturezaNFe(search, loading) {
      if (search.length) {
        loading(true);
        this.searchNaturezaNFe(loading, search, this);
      }
    },
    searchNaturezaNFe: _.debounce(async (loading, search, vm) => {
      vm.naturezas_nfe = await vm.getNaturezaByDescricao(search);
      if (loading) loading(false);
    }, 350),
    async getConfigurationList() {
      try {
        const response = await this.$http.post("/configuracoesgerais/find");
        const configuracao = Array.isArray(response.data)
          ? response.data[0] || {}
          : response.data || {};

        this.configuracoes = Array.isArray(response.data)
          ? response.data
          : [configuracao];
        this.retratoImpressao = configuracao.impressao_retrato_prevenda;
        this.margemNFCe = configuracao.impressao_margem_nfce;
        this.imprimir_nfce_a4 = configuracao?.imprimir_nfce_a4 ?? false;
        this.viasPrevenda = configuracao.imprimir_vias_prevenda;
        this.ultimo_nsu = configuracao.ultimo_nsu;
        this.verifica_cadastro_pessoa = configuracao.verifica_cadastro_pessoa;
        this.juros_simples = configuracao.juros_simples;
        this.taxa_diaria = configuracao.taxa_diaria;
        this.multa = configuracao.multa;
        this.descontar_icms_base_piscofins =
          configuracao.descontar_icms_base_piscofins;
        this.integracao_pos = configuracao.integracao_pos;
        this.vendas_cartao_conta_receber =
          configuracao.vendas_cartao_conta_receber;
        this.impressao_os_80_colunas = configuracao.impressao_os_80_colunas;
        this.impressao_msg_os = configuracao.impressao_msg_os;
        this.casas_decimal_quantidade = configuracao.casas_decimal_quantidade;
        this.casas_decimal_preco = configuracao.casas_decimal_preco;
        this.solicita_senha_adm = configuracao.solicita_senha_adm;
        this.abertura_caixa = configuracao?.abertura_caixa ?? false;
        this.fechamento_as_cegas = configuracao?.fechamento_as_cegas ?? false;
        this.calcular_st_desconto_icms =
          configuracao?.calcular_st_desconto_icms ?? false;
        this.duplicata_nfce = configuracao?.duplicata_nfce ?? false;
        this.impressao_duplicata_nfce_80_colunas =
          configuracao?.impressao_duplicata_nfce_80_colunas ?? false;
        this.gerar_conta_pagar = configuracao?.gerar_conta_pagar ?? false;
        this.utilizar_sempre_referencia =
          configuracao?.utilizar_sempre_referencia ?? false;
        this.considerar_qtd_tributavel =
          configuracao?.considerar_qtd_tributavel ?? false;
        this.importar_desc_complementar =
          configuracao?.importar_desc_complementar ?? false;
        this.somar_frete_despesas_baseicms =
          configuracao?.somar_frete_despesas_baseicms ?? false;
        this.sync_vendizap = configuracao?.sync_vendizap ?? false;
        this.considerar_obs = configuracao?.considerar_obs ?? false;
        this.mensagem_adicional = configuracao?.mensagem_adicional ?? false;
        this.mensagem_adicional_texto =
          configuracao?.mensagem_adicional_texto ?? null;
        this.impressao_pedido_80_colunas =
          response.data[0]?.impressao_pedido_80_colunas ?? false;
        this.impressao_pedido_faturado_80_colunas =
          response.data[0]?.impressao_pedido_faturado_80_colunas ?? false;
        this.relatorios_html = response.data[0]?.relatorios_html ?? false;
        this.importar_obs_pessoa =
          response.data[0]?.importar_obs_pessoa ?? false;
        this.referencia_danfe = response.data[0]?.referencia_danfe ?? false;
        this.desconto_incondicional =
          configuracao?.desconto_incondicional ?? false;
        this.ordenacao_produtos_prevenda =
          response.data[0]?.ordenacao_produtos_prevenda ?? false;
        this.ordenar_item_adicionado_por_ultimo_pdv =
          response.data[0]?.ordenar_item_adicionado_por_ultimo_pdv ?? false;
        this.impressao_paisagem_danfe =
          response.data[0]?.impressao_paisagem_danfe ?? false;
        this.verifica_estoque = response.data[0]?.verifica_estoque ?? false;
        this.custo_operacional = response.data[0]?.custo_operacional ?? false;
        this.custo_percentual = response.data[0]?.custo_percentual ?? false;
        this.nao_gerar_impressao =
          response.data[0]?.nao_gerar_impressao ?? false;
        this.fixar_natureza_nfe = response.data[0]?.fixar_natureza_nfe ?? false;
        await this.carregarNaturezaNFe(response.data[0]?.id_natureza_nfe);
        this.utilizar_sempre_descricao =
          configuracao?.utilizar_sempre_descricao ?? false;
        this.nao_converter_cfop = configuracao?.nao_converter_cfop ?? false;
        this.imprimir_codigo_barra_orcamento =
          configuracao?.imprimir_codigo_barra_orcamento ?? false;
        this.orcamento_com_foto = configuracao?.orcamento_com_foto ?? false;
        this.apresentar_objeto_identificador_orcamento =
          configuracao?.apresentar_objeto_identificador_orcamento ?? false;
        this.vendedor_obrigatorio = configuracao?.vendedor_obrigatorio ?? false;
        this.impressao_orcamento_80_colunas =
          configuracao?.impressao_orcamento_80_colunas ?? false;
        this.impressao_ncm = configuracao?.impressao_ncm ?? false;
        this.impressao_recibo_80_colunas =
          configuracao?.impressao_recibo_80_colunas ?? false;
        this.informacao_nfse = configuracao?.informacao_nfse ?? null;
        this.impressao_emitente_documentos =
          configuracao?.impressao_emitente_documentos ?? null;
        this.trabalhar_horas_os = configuracao?.trabalhar_horas_os ?? false;
        this.trabalhar_numero_interno_os =
          configuracao?.trabalhar_numero_interno_os ?? false;
        this.pedido_reduzido = configuracao?.pedido_reduzido ?? false;
        this.importar_obs_produto = configuracao?.importar_obs_produto ?? false;
        this.nao_imprimir_referencia =
          configuracao?.nao_imprimir_referencia ?? false;
        this.nao_movimentar_estoque =
          configuracao?.nao_movimentar_estoque ?? false;
        this.lucro_pis_cofins = configuracao?.lucro_pis_cofins ?? false;
        this.considerar_data_entrada =
          response.data[0]?.considerar_data_entrada ?? false;
        this.considerar_pedidos_faturados =
          response.data[0]?.considerar_pedidos_faturados ?? false;
        this.considerar_os_faturadas_nfse_feitas =
          response.data[0]?.considerar_os_faturadas_nfse_feitas ?? false;
        this.padrao_reforma_tributaria =
          response.data[0]?.padrao_reforma_tributaria ?? false;
        this.usar_codigo_balanca =
          response.data[0]?.usar_codigo_balanca ?? false;
        this.bloquear_venda_cliente_inadimplente =
          configuracao?.bloquear_venda_cliente_inadimplente ?? false;
        this.limite_inadimplencia_permitida =
          configuracao?.limite_inadimplencia_permitida ?? 0;
        this.desconsiderar_estoque_condicional =
          configuracao?.desconsiderar_estoque_condicional ?? false;
        this.observacao_fixa_os =
          this.normalizarObservacaoFixa(configuracao?.observacao_fixa_os) ||
          null;
        this.observacao_fixa_orcamento =
          this.normalizarObservacaoFixa(
            configuracao?.observacao_fixa_orcamento
          ) || null;
        this.fixar_observacao_os =
          configuracao?.fixar_observacao_os ?? !!this.observacao_fixa_os;
        this.fixar_observacao_orcamento =
          configuracao?.fixar_observacao_orcamento ??
          !!this.observacao_fixa_orcamento;
        this.restaurante_producao_etapa_unica =
          configuracao?.restaurante_producao_etapa_unica ?? false;
        this.restaurante_usar_apenas_comandas =
          configuracao?.restaurante_usar_apenas_comandas ?? false;
        this.restaurante_cardapio_online_ativo =
          configuracao?.restaurante_cardapio_online_ativo ?? false;
        this.restaurante_self_pedido_ativo =
          configuracao?.restaurante_self_pedido_ativo ?? false;
        this.restaurante_impressao_pedidos_80_colunas =
          configuracao?.restaurante_impressao_pedidos_80_colunas ?? false;
        this.restaurante_impressora_checkout =
          configuracao?.restaurante_impressora_checkout ?? null;
        this.restaurante_impressora_cozinha =
          configuracao?.restaurante_impressora_cozinha ?? null;
        this.restaurante_impressora_bar =
          configuracao?.restaurante_impressora_bar ?? null;
        this.restaurante_impressora_comprovante_cliente =
          configuracao?.restaurante_impressora_comprovante_cliente ?? null;
      } catch (error) {
        this.$toast.error(
          error?.response?.data?.msg ||
            "Não foi possível carregar as configurações gerais."
        );
      }
    },
    async salvarConfigs() {
      this.addLoadingToButton("submit_nova_configs");
      try {
        if (
          this.bloquear_venda_cliente_inadimplente &&
          Number(this.limite_inadimplencia_permitida) < 0
        ) {
          this.$toast.error("Informe um valor limite de inadimplência válido.");
          this.removeLoadingToButton("submit_nova_configs");
          return;
        }

        if (
          this.restaurante_impressao_pedidos_80_colunas &&
          (!this.restaurante_impressora_cozinha ||
            !this.restaurante_impressora_bar)
        ) {
          this.$toast.error(
            "Informe as impressoras da cozinha e do bar para ativar a impressão do restaurante."
          );
        }

        if (this.fixar_natureza_nfe && !this.natureza_nfe?.id) {
          this.$toast.error("Selecione uma natureza padrão para a NFe.");
          this.removeLoadingToButton("submit_nova_configs");
          return;
        }

        await this.$http.post("/configuracoesgerais/create", {
          impressao_retrato_prevenda: this.retratoImpressao ?? false,
          impressao_margem_nfce: this.margemNFCe ?? false,
          imprimir_nfce_a4: this.imprimir_nfce_a4 ?? false,
          imprimir_vias_prevenda: this.viasPrevenda ?? false,
          ultimo_nsu: this.ultimo_nsu ?? null,
          verifica_cadastro_pessoa: this.verifica_cadastro_pessoa ?? null,
          juros_simples: this.juros_simples ?? null,
          taxa_diaria: this.taxa_diaria ?? null,
          multa: this.multa ?? null,
          descontar_icms_base_piscofins:
            this.descontar_icms_base_piscofins ?? null,
          integracao_pos: this.integracao_pos ?? null,
          vendas_cartao_conta_receber: this.vendas_cartao_conta_receber ?? null,
          impressao_os_80_colunas: this.impressao_os_80_colunas ?? null,
          casas_decimal_preco: this.casas_decimal_preco ?? null,
          casas_decimal_quantidade: this.casas_decimal_quantidade ?? null,
          impressao_msg_os: this.impressao_msg_os ?? null,
          solicita_senha_adm: this.solicita_senha_adm ?? null,
          abertura_caixa: this.abertura_caixa,
          fechamento_as_cegas: this.abertura_caixa
            ? this.fechamento_as_cegas
            : false,
          calcular_st_desconto_icms: this.calcular_st_desconto_icms ?? null,
          duplicata_nfce: this.duplicata_nfce ?? null,
          impressao_duplicata_nfce_80_colunas: this.duplicata_nfce
            ? this.impressao_duplicata_nfce_80_colunas ?? false
            : false,
          gerar_conta_pagar: this.gerar_conta_pagar ?? null,
          utilizar_sempre_referencia: this.utilizar_sempre_referencia ?? null,
          considerar_qtd_tributavel: this.considerar_qtd_tributavel ?? null,
          importar_desc_complementar: this.importar_desc_complementar ?? false,
          somar_frete_despesas_baseicms:
            this.somar_frete_despesas_baseicms ?? false,
          sync_vendizap: this.sync_vendizap ?? false,
          considerar_obs: this.considerar_obs ?? false,
          mensagem_adicional: this.mensagem_adicional ?? false,
          mensagem_adicional_texto: this.mensagem_adicional_texto ?? null,
          impressao_pedido_80_colunas:
            this.impressao_pedido_80_colunas ?? false,
          impressao_pedido_faturado_80_colunas:
            this.impressao_pedido_faturado_80_colunas ?? false,
          relatorios_html: this.relatorios_html ?? false,
          importar_obs_pessoa: this.importar_obs_pessoa ?? false,
          referencia_danfe: this.referencia_danfe ?? false,
          desconto_incondicional: this.desconto_incondicional ?? false,
          ordenacao_produtos_prevenda:
            this.ordenacao_produtos_prevenda ?? false,
          ordenar_item_adicionado_por_ultimo_pdv:
            this.ordenar_item_adicionado_por_ultimo_pdv ?? false,
          impressao_paisagem_danfe: this.impressao_paisagem_danfe ?? false,
          verifica_estoque: this.verifica_estoque ?? false,
          custo_operacional: this.custo_operacional ?? false,
          custo_percentual: this.custo_percentual ?? false,
          nao_gerar_impressao: this.nao_gerar_impressao ?? false,
          fixar_natureza_nfe: this.fixar_natureza_nfe ?? false,
          id_natureza_nfe: this.fixar_natureza_nfe
            ? this.natureza_nfe?.id
            : null,
          utilizar_sempre_descricao: this.utilizar_sempre_descricao ?? false,
          nao_converter_cfop: this.nao_converter_cfop ?? false,
          imprimir_codigo_barra_orcamento:
            this.imprimir_codigo_barra_orcamento ?? false,
          orcamento_com_foto: this.orcamento_com_foto ?? false,
          apresentar_objeto_identificador_orcamento:
            this.apresentar_objeto_identificador_orcamento ?? false,
          vendedor_obrigatorio: this.vendedor_obrigatorio ?? false,
          impressao_orcamento_80_colunas:
            this.impressao_orcamento_80_colunas ?? false,
          impressao_ncm: this.impressao_ncm ?? false,
          impressao_recibo_80_colunas:
            this.impressao_recibo_80_colunas ?? false,
          informacao_nfse: this.informacao_nfse ?? false,
          impressao_emitente_documentos:
            this.impressao_emitente_documentos ?? false,
          trabalhar_horas_os: this.trabalhar_horas_os ?? false,
          trabalhar_numero_interno_os:
            this.trabalhar_numero_interno_os ?? false,
          pedido_reduzido: this.pedido_reduzido ?? false,
          importar_obs_produto: this.importar_obs_produto ?? false,
          nao_imprimir_referencia: this.nao_imprimir_referencia ?? false,
          nao_movimentar_estoque: this.nao_movimentar_estoque ?? false,
          lucro_pis_cofins: this.lucro_pis_cofins ?? false,
          considerar_data_entrada: this.considerar_data_entrada ?? false,
          considerar_pedidos_faturados:
            this.considerar_pedidos_faturados ?? false,
          considerar_os_faturadas_nfse_feitas:
            this.considerar_os_faturadas_nfse_feitas ?? false,
          padrao_reforma_tributaria: this.padrao_reforma_tributaria ?? false,
          usar_codigo_balanca: this.usar_codigo_balanca ?? false,
          bloquear_venda_cliente_inadimplente:
            this.bloquear_venda_cliente_inadimplente ?? false,
          limite_inadimplencia_permitida: this
            .bloquear_venda_cliente_inadimplente
            ? this.limite_inadimplencia_permitida ?? 0
            : 0,
          desconsiderar_estoque_condicional:
            this.desconsiderar_estoque_condicional ?? false,
          fixar_observacao_os: this.fixar_observacao_os ?? false,
          fixar_observacao_orcamento: this.fixar_observacao_orcamento ?? false,
          observacao_fixa_os: this.fixar_observacao_os
            ? this.normalizarObservacaoFixa(this.observacao_fixa_os) || null
            : null,
          observacao_fixa_orcamento: this.fixar_observacao_orcamento
            ? this.normalizarObservacaoFixa(this.observacao_fixa_orcamento) ||
              null
            : null,
          restaurante_producao_etapa_unica:
            this.restaurante_producao_etapa_unica ?? false,
          restaurante_usar_apenas_comandas:
            this.restaurante_usar_apenas_comandas ?? false,
          restaurante_impressao_pedidos_80_colunas:
            this.restaurante_impressao_pedidos_80_colunas ?? false,
          restaurante_impressora_checkout: this
            .restaurante_impressao_pedidos_80_colunas
            ? this.restaurante_impressora_checkout
            : null,
          restaurante_impressora_cozinha: this
            .restaurante_impressao_pedidos_80_colunas
            ? this.restaurante_impressora_cozinha
            : null,
          restaurante_impressora_bar: this
            .restaurante_impressao_pedidos_80_colunas
            ? this.restaurante_impressora_bar
            : null,
          restaurante_impressora_comprovante_cliente: this
            .restaurante_impressao_pedidos_80_colunas
            ? this.restaurante_impressora_comprovante_cliente
            : null,
        });
        clienteInadimplenciaStore.bloquearVendaClienteInadimplente =
          this.bloquear_venda_cliente_inadimplente ?? false;
        clienteInadimplenciaStore.limiteInadimplenciaPermitida = this
          .bloquear_venda_cliente_inadimplente
          ? this.limite_inadimplencia_permitida ?? 0
          : 0;
        this.$toast.success("Configuração foi salva com sucesso!");
      } catch (error) {
        this.$toast.error(
          error?.response?.data?.msg ||
            "Não foi possível salvar as configurações gerais."
        );
      }
      this.removeLoadingToButton("submit_nova_configs");
    },
    async carregarImpressorasRestaurante() {
      this.restaurante_qz_carregando = true;
      this.restaurante_qz_status = "Aguardando autorização do QZ Tray.";

      try {
        this.restaurante_impressoras_qz = await listarImpressorasQz();

        if (!this.restaurante_impressoras_qz.length) {
          this.restaurante_qz_status =
            "QZ Tray conectado, mas nenhuma impressora foi encontrada neste computador.";
          this.$toast.warning(
            "Nenhuma impressora encontrada neste computador."
          );
          return;
        }

        this.restaurante_qz_status = `${this.restaurante_impressoras_qz.length} impressora(s) carregada(s) pelo QZ Tray.`;
        this.$toast.success("Impressoras carregadas pelo QZ Tray.");
      } catch (error) {
        this.restaurante_qz_status =
          error.message ||
          "Não foi possível conectar ao QZ Tray neste computador.";
        this.$toast.error(error.message);
      } finally {
        this.restaurante_qz_carregando = false;
      }
    },
    configurarQzMac() {
      this.restaurante_qz_configurando_mac = true;

      try {
        const script = `#!/bin/bash
set -euo pipefail

QZ_JAVA="/Applications/QZ Tray.app/Contents/PlugIns/Java.runtime/Contents/Home/bin/java"
QZ_JAR="/Applications/QZ Tray.app/Contents/Resources/qz-tray.jar"
QZ_DIR="$HOME/Library/Application Support/qz"
CERT_DST="$QZ_DIR/nuts-qz-certificate.txt"
CERT_DL="$HOME/Downloads/nuts-qz-certificate.txt"
PLIST="$HOME/Library/LaunchAgents/io.qz.nuts-trusted.plist"

mkdir -p "$QZ_DIR"

if [ ! -f "$CERT_DST" ]; then
  if [ -f "$CERT_DL" ]; then
    cp "$CERT_DL" "$CERT_DST"
  else
    echo "Baixe o certificado no painel antes de executar este script."
    exit 1
  fi
fi

cat > "$PLIST" <<EOF
<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE plist PUBLIC "-//Apple//DTD PLIST 1.0//EN" "http://www.apple.com/DTDs/PropertyList-1.0.dtd">
<plist version="1.0">
    <dict>
        <key>Label</key><string>io.qz.nuts-trusted</string>
        <key>RunAtLoad</key><true/>
        <key>KeepAlive</key>
        <dict>
            <key>SuccessfulExit</key><false/>
        </dict>
        <key>ProgramArguments</key>
        <array>
            <string>$QZ_JAVA</string>
            <string>-Xms512m</string>
            <string>-DtrustedRootCert=$CERT_DST</string>
            <string>-jar</string>
            <string>$QZ_JAR</string>
            <string>-NSRequiresAquaSystemAppearance</string>
            <string>False</string>
        </array>
    </dict>
</plist>
EOF

pkill -f "qz-tray.jar" 2>/dev/null || true
launchctl bootout "gui/$(id -u)" /Library/LaunchAgents/io.qz.qz-tray.plist 2>/dev/null || true
launchctl bootout "gui/$(id -u)" "$PLIST" 2>/dev/null || true
launchctl bootstrap "gui/$(id -u)" "$PLIST"

echo "QZ Tray configurado com confianca permanente."
`;

        const blob = new Blob([script], { type: "application/x-sh" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "configurar-qz-macos.command";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$toast.success(
          "Script baixado. Execute-o no Mac (duplo clique) apos baixar o certificado."
        );
      } catch (error) {
        this.$toast.error("Nao foi possivel gerar o script de configuracao.");
      } finally {
        this.restaurante_qz_configurando_mac = false;
      }
    },
    configurarQzWindows() {
      this.restaurante_qz_configurando_windows = true;

      try {
        // .bat que instala o certificado do sistema na trust store do QZ Tray
        // (override.crt) e reinicia o servico. Resolve o "Allow" que nunca
        // fica marcado no Windows (prompt untrusted). Execute como admin.
        const script = `@echo off
chcp 65001 >nul
setlocal

REM ============================================================
REM Configuracao de confianca permanente do QZ Tray (Nuts)
REM Execute este arquivo como ADMINISTRADOR (botao direito).
REM ============================================================

echo.
echo Configurando confianca permanente do QZ Tray...
echo.

set "QZ_DIR=%ProgramFiles%\\QZ Tray"
set "CERT_SRC=%USERPROFILE%\\Downloads\\nuts-qz-certificate.txt"
set "CERT_DST=%QZ_DIR%\\override.crt"

REM Localiza o jar do QZ Tray (pode variar entre versoes)
set "QZ_JAR="
if exist "%QZ_DIR%\\qz-tray.jar" set "QZ_JAR=%QZ_DIR%\\qz-tray.jar"
if exist "%ProgramFiles(x86)%\\QZ Tray\\qz-tray.jar" set "QZ_JAR=%ProgramFiles(x86)%\\QZ Tray\\qz-tray.jar"

if not exist "%CERT_SRC%" (
  echo [ERRO] Certificado nao encontrado em: %CERT_SRC%
  echo Baixe o certificado no painel do Nuts antes de executar este script.
  echo.
  pause
  exit /b 1
)

REM Verifica privilegios de administrador
net session >nul 2>&1
if %errorLevel% neq 0 (
  echo [ERRO] Este script precisa ser executado como ADMINISTRADOR.
  echo Clique com o botao direito e selecione "Executar como administrador".
  echo.
  pause
  exit /b 1
)

copy /Y "%CERT_SRC%" "%CERT_DST%" >nul
if %errorLevel% neq 0 (
  echo [ERRO] Nao foi possível copiar o certificado. Confirme que o QZ Tray
  echo esta instalado em: %QZ_DIR%
  pause
  exit /b 1
)

echo Certificado instalado em: %CERT_DST%
echo.

REM Encerra instancias em execucao do QZ Tray
taskkill /F /IM "qz-tray.exe" >nul 2>&1
timeout /t 2 /nobreak >nul

REM Reinicia o QZ Tray com o certificado confiavel (se o jar foi localizado)
if defined QZ_JAR (
  echo Reiniciando o QZ Tray com confianca permanente...
  start "" "%QZ_JAR%"
)

echo.
echo ============================================================
echo QZ Tray configurado com confianca permanente.
echo Feche e abra o navegador; a tela de "Allow" nao deve mais aparecer.
echo ============================================================
echo.
pause
`;

        const blob = new Blob([script], { type: "text/plain;charset=utf-8" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "configurar-qz-windows.bat";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$toast.success(
          "Script baixado. Execute-o no Windows como administrador (botão direito) após baixar o certificado."
        );
      } catch (error) {
        this.$toast.error("Não foi possível gerar o script de configuração.");
      } finally {
        this.restaurante_qz_configurando_windows = false;
      }
    },
    async baixarCertificadoQz() {
      this.restaurante_qz_baixando_certificado = true;

      try {
        const { data } = await this.$http.get("/restaurante/qz/certificate");

        if (!data || !data.enabled || !data.certificate) {
          this.$toast.error(
            "Certificado do QZ Tray ainda nao esta disponivel no servidor."
          );
          return;
        }

        const blob = new Blob([data.certificate], {
          type: "text/plain;charset=utf-8",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "nuts-qz-certificate.txt";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$toast.success(
          "Certificado baixado. Siga as instrucoes para confiar permanentemente."
        );
      } catch (error) {
        this.$toast.error("Nao foi possivel baixar o certificado do QZ Tray.");
      } finally {
        this.restaurante_qz_baixando_certificado = false;
      }
    },
    async testarImpressaoRestaurante(destino) {
      const impressoras = {
        checkout: this.restaurante_impressora_checkout,
        comprovante: this.restaurante_impressora_comprovante_cliente,
        cozinha: this.restaurante_impressora_cozinha,
        bar: this.restaurante_impressora_bar,
      };

      try {
        await imprimirTextoQz(
          impressoras[destino],
          ticketTesteProducao(destino)
        );
        this.$toast.success("Teste enviado para a impressora.");
      } catch (error) {
        this.$toast.error(error.message);
      }
    },
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getConfigurationList();
    this.contas_marcadas_color = localStorage.getItem("contas_marcadas_color");
    if (this.$route.query.aba === "balancas") {
      this.abaConfiguracaoAtiva = this.abaBalancasIndex;
    }
  },
  watch: {
    restaurante_impressao_pedidos_80_colunas(value) {
      if (value && !this.restaurante_impressoras_qz.length) {
        this.carregarImpressorasRestaurante();
      }
    },
    contas_marcadas_color: {
      handler(color) {
        localStorage.setItem("contas_marcadas_color", color);
      },
    },
  },
};
</script>
